import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-authorization-failed',
  templateUrl: './authorization-failed.component.html',
  styleUrls: ['./authorization-failed.component.css']
})
export class AuthorizationFailedComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }
}
